const IS_DEV: boolean =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const BASE_URL = IS_DEV
  ? "http://localhost:3001/"
  : "https://api.slowtourtuscany.it/";
export const BASE_URL_API = BASE_URL + "platform/v1/";